export const getPreviewLocation = (showAndroid, showExpanded, locale = 'default-locale') => {
  const key = `${locale}-${showAndroid ? 'android' : 'default'}`;
  return showExpanded ? `${key}-expanded` : key;
};

/* 
  In-app templates can be set to have one of four positions
  on the device screen: Bottom, Center, Full, or Top.

  That information is saved in the template as `inAppDisplaySettings`, which has some interesting information.

  The getInAppPosition helper function interpolates the data and spits out where we want to display the message.
*/
export const getInAppPosition = ({ bottom, top } = {}) => {
  if (bottom?.displayOption === 'AutoExpand' && top?.displayOption === 'AutoExpand') {
    return 'center';
  } else if (bottom?.displayOption === 'AutoExpand') {
    return 'top';
  } else if (top?.displayOption === 'AutoExpand') {
    return 'bottom';
  } else {
    return 'full';
  }
};
